import { Fluent } from "@serenity-is/corelib";

export default async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text);
    } catch (err) {
        var el = document.createElement('textarea');
        el.setAttribute('style', `position: absolute, left: -9999px, top: ${(window.scrollY || document.documentElement.scrollTop)}px`);
        el.setAttribute('readonly', '');
        el.value = text;
        var lastDialog = Array.from(document.querySelectorAll<HTMLElement>('.ui-dialog-content, .s-Panel, .modal')).filter(Fluent.isVisibleLike).pop();
        if (lastDialog)
            lastDialog.append(el);
        else
            document.body.append(el);
        el.select();
        (document as any)["execCommand"]("copy");
        el.remove();
    }
}